define(function(require, exports, module) {
    var organ = {
        t: null,
        init: function() {
            var self = this;
            self.organKeyHover();
        },
        organKeyHover: function() {
            var self = this;
            $(".organ-key .banner-organ .small").hover(function() {
                var _this = this;
                var thisLi = $(_this).parents(".organ-key");
                var activeLi = thisLi.parent().find(".active");

                self.t = setTimeout(function() {
                    activeLi.removeClass("active");
                    thisLi.addClass("active");
                }, 100);

            }, function() {
                clearTimeout(self.t);
            });
        }
    };
    exports.fn = organ;
});



// WEBPACK FOOTER //
// ./src/js/unit/organ/organ.js